const tabs = {
  "challenge-editor.tabs.info": "Info",
  "challenge-editor.tabs.media": "Media",
  "challenge-editor.tabs.scenarios": "Scenarios",
  "challenge-editor.tabs.targets": "Targets",
};

const buttons = {
  "challenge-editor.buttons.validate-json": "VALIDATE JSON",
};

const dialog = {
  "challenge-editor.dialog.validation-errors.title": "Validation Errors",
  "challenge-editor.dialog.validation-errors.message": "There are validation errors in ({{field}}). Please fix them before proceeding.",
};

export const challengeEditor = {
  ...tabs,
  ...buttons,
  ...dialog,
}; 